/**
 * Generates a MongoDB-style ObjectId
 * ObjectId is a 12-byte identifier consisting of:
 * - 4-byte timestamp (seconds since epoch)
 * - 5-byte random value unique to machine and process
 * - 3-byte incrementing counter (initialized randomly)
 */

let counter = Math.floor(Math.random() * 0xffffff);

const generateObjectId = (): string => {
  const timestamp = Math.floor(Date.now() / 1000);
  
  // Random 5-byte value
  const randomBytes = new Array(5)
    .fill(0)
    .map(() => Math.floor(Math.random() * 256));
  
  // 3-byte counter
  counter = (counter + 1) % 0xffffff;
  const counterBytes = [
    (counter >> 16) & 0xff,
    (counter >> 8) & 0xff,
    counter & 0xff
  ];
  
  // Combine all bytes
  const bytes = [
    (timestamp >> 24) & 0xff,
    (timestamp >> 16) & 0xff,
    (timestamp >> 8) & 0xff,
    timestamp & 0xff,
    ...randomBytes,
    ...counterBytes
  ];
  
  // Convert to hex string
  return bytes.map(b => b.toString(16).padStart(2, '0')).join('');
};

export { generateObjectId };